var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagedinvestmentstrategy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 6,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1018_24509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.07 12.93L25.66 14.34C27.1 15.79 28 17.79 28 20C28 24.42 24.42 28 20 28C15.58 28 12 24.42 12 20C12 15.92 15.05 12.56 19 12.07V14.09C16.16 14.57 14 17.03 14 20C14 23.31 16.69 26 20 26C23.31 26 26 23.31 26 20C26 18.34 25.33 16.84 24.24 15.76L22.83 17.17C23.55 17.9 24 18.9 24 20C24 22.21 22.21 24 20 24C17.79 24 16 22.21 16 20C16 18.14 17.28 16.59 19 16.14V18.28C18.4 18.63 18 19.26 18 20C18 21.1 18.9 22 20 22C21.1 22 22 21.1 22 20C22 19.26 21.6 18.62 21 18.28V10H20C14.48 10 10 14.48 10 20C10 25.52 14.48 30 20 30C25.52 30 30 25.52 30 20C30 17.24 28.88 14.74 27.07 12.93Z",
    fill: "#168617"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1018_24509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagedinvestmentstrategy);
export default __webpack_public_path__ + "static/media/Managedinvestmentstrategy.07a5fe7c42170dd90332fa30e578ea48.svg";
export { ForwardRef as ReactComponent };